module.exports = __webpack_public_path__ + "img/2.b6e4ea06.png";